var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 15.28v25.44C56 49.164 49.164 56 40.72 56H15.28a15.234 15.234 0 01-11.353-5.053A15.211 15.211 0 010 40.72V15.28c0-2.997.864-5.797 2.362-8.16A15.263 15.263 0 0115.28 0h25.44C49.164 0 56 6.836 56 15.28z",
    fill: "url(#logo_svg__paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.408 46.867l12.064-9.33-26.71-24.63L6.19 40.818l23.844 6.53c.82.218 1.696.043 2.374-.482z",
    fill: "#F5F9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.984 40.807l13.42-11.473 13.87-10.708c.864-.667 2.056.208 1.684 1.236l-6.475 17.675-22.499 3.27zM17.762 12.906L7.482 41.17v.01l-3.555 9.768A15.211 15.211 0 010 40.72V15.28c0-2.997.864-5.797 2.362-8.16l15.4 5.786z",
    fill: "#F5F9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.763 12.906L7.459 41.17l4.638 1.258 5.666-29.52zM44.472 37.537L37.756 27.52l-2.253 1.75 8.969 8.268z",
    fill: "#CAD1EF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__paint0_linear",
    x1: 43.56,
    y1: 10.429,
    x2: 9.473,
    y2: 48.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4284FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#1B47EE"
  })))));
}
export default __webpack_public_path__ + "static/logo.1e80c910.svg";
export { SvgLogo as ReactComponent };